export default function animateBurgerIcon() {
    const burgerIcons = document.querySelectorAll(".burger-icon-container.is-animated");

    Array.from(burgerIcons).map(item => {
        item.addEventListener("click", () => item.classList.toggle("is-active"));
    });

    let burger = document.querySelector(".burger-icon-container");
    let header = document.querySelector(".main-header");

    if(!document.querySelector(".page-wrapper.content-wrapper").classList.contains("header-color")) {
        burger.addEventListener("click", () => {
            header.classList.toggle("change-bg");
        });
    }
}
